<template>
  <div class="interlayer">
    <empty-interlayer v-if="type == 1" :height="data.height" />
    <image-interlayer
      v-else-if="type == 2"
      :image="data.image"
      :showMore="data.showMore"
      :url="data.url"
    />
    <timer-interlayer
      v-else-if="type == 3"
      :image="data.image"
      :showMore="data.showMore"
      :url="data.url"
      :start="data.start"
      :end="data.end"
    />
  </div>
</template>
<script>
export default {
  name: "Interlayer",

  props: {
    type: {
      type: Number,
      required: true
    },
    data: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="less" scoped>
.interlayer {
  padding: 0 8px;
}
</style>